import styles from "../style.module.css";
import {useSelector, useDispatch} from "react-redux";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";
import {useEffect, useState} from "react";
import "swiper/css";
import {getContactInfo} from "../../../store/contactPage/contactPageFetch";
import langData from "../../../lang/data";

function BankSection() {
    const {currentLanguage} = useSelector(({main}) => main);
    const {contactPage} = useSelector((state) => state.ContactPageSlice);

    const dispatch = useDispatch();

    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        dispatch(getContactInfo());
    }, [dispatch]);

    const addresses = contactPage?.addresses || [];

    const banksAboutList = [
        {
            id: 1,
            img: "https://vlv.am/public/img/ineco.png",
        },
        {
            id: 3,
            img: "https://vlv.am/public/img/idram.svg",
        },
        {
            id: 4,
            img: "https://vlv.am/public/img/aeb.png",
        },
        {
            id: 7,
            img: "https://vlv.am/public/img/ameria.svg",
        },
        {
            id: 8,
            img: "https://vlv.am/public/img/converse.png",
        },
        {
            id: 9,
            img: "https://vlv.am/public/img/arcax.png",
        },
        {
            id: 10,
            img: "https://vlv.am/public/img/vtb.png",
        },
        {
            id: 12,
            img: "https://vlv.am/public/img/acba.png",
        },
    ];

    return (
        <div className={styles.bank_section}>
            <div className={styles.branch_slider}>
                <button className={`${styles.prevBtn} prev-btn`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="20" viewBox="0 0 13 22" fill="none">
                        <path d="M11.1816 1L1.41016 10.8222L11.1816 20.6444" stroke="#282828" strokeWidth="2"
                              strokeLinecap="round"/>
                    </svg>
                </button>
                <Swiper
                    modules={[Navigation]}
                    loop={true}
                    slidesPerView={1}
                    spaceBetween={20}
                    onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                    navigation={{
                        prevEl: ".prev-btn",
                        nextEl: ".next-btn",
                    }}
                >
                    {
                        addresses.map((address) => (
                            <SwiperSlide key={address.id}>
                                <div className={styles.image_wrapper}>
                                    <img
                                        src={process.env.REACT_APP_STORAGE_URL + address[`image_${currentLanguage}`]}
                                        alt={address.name}
                                        className={styles.bank_branch_image}
                                    />
                                </div>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
                <button className={`${styles.nextBtn} next-btn`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="20" viewBox="0 0 13 22" fill="none">
                        <path d="M1.00006 1L10.7715 10.8222L1.00006 20.6444" stroke="#282828" strokeWidth="2"
                              strokeLinecap="round"/>
                    </svg>
                </button>
            </div>
            <div className={styles.bank_info_section}>
                <div className={styles.bank_info_text_content}>
                    <h2>{langData.titles.banks[currentLanguage]}</h2>
                    <span>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                    </span>
                </div>
                <div className={styles.bank_info_slide}>
                    <Swiper
                        slidesPerView={1.5}
                        spaceBetween = { 10 }
                        breakpoints={{
                            480: {
                                slidesPerView: 2.2,
                                spaceBetween: 15,
                            },
                            768: {
                                slidesPerView: 3.2,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 4.5,
                                spaceBetween: 20,
                            }
                        }}
                    >
                        {
                            banksAboutList.map((bank) => (
                                <SwiperSlide key={bank.id}>
                                    <div className={styles.image_wrapper}>
                                        <img
                                            src={bank.img}
                                            alt = 'bank image'
                                            className={styles.bank_image}
                                        />
                                    </div>
                                </SwiperSlide>
                            ))
                        }
                    </Swiper>
                </div>
            </div>
        </div>
    );
}

export default BankSection;